import React from "react";
import { connect } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const PrivateRoute = ({ isAuthenticated, children }) => {
  const location = useLocation();

  // Don't redirect if already on signup or staff login pages
  if (
    !isAuthenticated &&
    location.pathname !== "/signup" &&
    location.pathname !== "/staff/login"
  ) {
    return <Navigate to="/signup" replace />;
  }

  return children;
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.user.isAuthenticated,
});

export default connect(mapStateToProps, {})(PrivateRoute);
